import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { cx } from './cx';

/**
 * 232px of navigation down the left of an area.
 *
 * A sidebar rather than the tab strip it replaces: ten tabs across the top had no room to
 * say what any of them was for, and the two that mattered to a dispatcher sat beside eight
 * that belong to whoever runs the firm.
 */
export function Sidebar({ className, children }: { className?: string; children?: ReactNode }) {
  return (
    <nav
      className={cx(
        'w-[232px] shrink-0 p-3 border-r border-rule bg-surface flex flex-col gap-3.5 overflow-y-auto',
        className,
      )}
    >
      {children}
    </nav>
  );
}

export function SidebarGroup({ label, children }: { label: ReactNode; children?: ReactNode }) {
  return (
    <div className="flex flex-col gap-px">
      <div className="px-2.5 pt-1 pb-[5px] text-caps font-semibold tracking-[0.06em] uppercase text-ink-3">
        {label}
      </div>
      {children}
    </div>
  );
}

export function SidebarItem({ to, children }: { to: string; children?: ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        cx(
          'flex items-center gap-2 h-[30px] px-2.5 rounded-control text-nav no-underline',
          isActive ? 'bg-surface-2 text-ink font-semibold' : 'text-ink-2 hover:bg-surface-2',
        )
      }
    >
      {children}
    </NavLink>
  );
}
